import React, { useState } from "react";
import WplPopup from "../wpl-popup-window/WplPopup";
import uploadLogo from "../../assets/img/cloud_upload-34px.svg";
import documentLogo from "../../assets/img/document_logo.svg";
import deleteIcon from "../../assets/img/delete-icon-color.png"
import "../wpl-table/wpl-table.css";
import "./user-action-wpl-file-upload.css";

export default function UserActionsWplFileUpload({
    didSelectFile,
    asPopup = true,
    displayFiles = true,
    text = null,
    style = null,
    disabled = false,
    warningMessage = "Document upload is only available for one turbine at a time.",
    didDeleteFile,
    files = {},
}) {
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [dragging, setDragging] = useState(false);

    const dragEnter = (e) => {
        e.preventDefault();
        setDragging(true);
    };
    const dragLeave = (e) => {
        e.preventDefault();
        setDragging(false);
    };
    const fileDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        setDragging(false);

        addFiles(Array.from(files));
    };

    function addFiles(files) {
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                try {
                    await didSelectFile(file.name, reader.result);
                } catch (err) {
                    console.error(`[Upload] Error uploading file ${file.name}:`, err);
                }
            };
            reader.readAsDataURL(file);
        });
    }


    function handleFileUpload(e) {
        e.preventDefault();
        if (disabled) return;

        const files = Array.from(e.target.files);
        addFiles(files);
        e.target.value = null;
    }

    function handleDeleteFile(fileName) {
        if (didDeleteFile) {
            didDeleteFile(fileName);
        }
    }


    function renderInside() {
        return (
            <div className="wpl-file-upload" style={style}>
                {disabled && (
                    <div className="overlay">
                        <div className="warning-message">{warningMessage}</div>
                    </div>
                )}
                <div
                    className={`upload-field ${dragging ? "dragging" : ""}`}
                    style={{
                        pointerEvents: disabled ? "none" : "auto",
                        opacity: disabled ? 0.5 : 1,
                    }}
                    onDragEnter={dragEnter}
                    onDragLeave={dragLeave}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={fileDrop}
                >

                    {displayFiles && Object.keys(files).length > 0 ? (
                        <div className="file-list">
                            {Object.keys(files).map((fileName) => {
                                return (
                                    <div key={fileName} className="file-row">
                                        <span className="file-name">{fileName}</span>
                                        <div className="file-actions">
                                            <button
                                                className="delete-file-button"
                                                onClick={() => handleDeleteFile(fileName)}
                                                title="Remove file"
                                            >
                                                <img src={deleteIcon} className="delete-icon" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) :
                        <div className="upload-placeholder">
                            <img src={uploadLogo} alt="drop files here" />
                            <p>{text === null ? "Drag and drop files, or" : text}</p>
                        </div>

                    }

                    <label className={`styled-file-selector ${dragging ? "dragging" : ""}`}>
                        <input
                            className="file-selector"
                            type="file"
                            multiple
                            onChange={handleFileUpload}
                        />
                        Browse Files
                    </label>
                </div>
            </div>
        );
    }

    if (!asPopup) {
        return <div className="user-action-wpl-file-upload-page">{renderInside()}</div>;
    }

    return (
        <div className="user-action-wpl-file-upload-page">
            <div
                className="open-window-button"
                onClick={() => setShowUploadPopup(true)}
            >
                <img src={documentLogo} alt="click to open document window" />
            </div>
            <WplPopup showPopup={showUploadPopup} closePopup={setShowUploadPopup}>
                <h1>Upload documents</h1>
                <div>&nbsp;</div>
                {renderInside()}
            </WplPopup>
        </div>
    );
}
